import { ICellRendererParams } from "ag-grid-community";

export default function PayableCellRenderer(params: ICellRendererParams) {
  const status = params.data?.payables_status?.column_value;

  const color =
    status === "Pending" ? "#FF914D" : status === "Paid" ? "#17B26A" : "#ccc";

  return (
    <div className="space-x-2">
      <span>{params.value ?? ""}</span>
      <span style={{ color }}>{status ? `(${status})` : ""}</span>
    </div>
  );
}
